import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const standardsContentCss = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  width: "100%",
  marginTop: "32px",
};

export const standardsTitleCss = {
  fontWeight: "700",
  fontSize: "12px",
  lineHeight: "133%",
  letterSpacing: "1px",
  color: ui.neutral[400],
  textTransform: "uppercase",
  margin: "0",
};

export const standardsElementContentCss = {
  width: "100%",
  marginTop: "8px",
};
